module.exports = __webpack_public_path__ + "fonts/ysbth.1726685c.ttf";